// extracted by mini-css-extract-plugin
export var numpadContainer = "_mg-1";
export var phoneButton = "_mg-0";